import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';

interface CTASectionProps {
  onCTAClick: () => void;
}

const CTASection: React.FC<CTASectionProps> = ({ onCTAClick }) => {
  return (
    <section className="py-10 sm:py-16 px-3 xs:px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-accent-600 to-pink-600 text-white">
      <div className="max-w-4xl mx-auto text-center">
        <SparklesIcon className="w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-4 sm:mb-6 animate-bounce" />
        <h2 className="text-2xl xs:text-3xl sm:text-5xl font-bold mb-4 sm:mb-6">
          Ready to Get Started?
        </h2>
        <p className="text-base sm:text-xl text-accent-100 mb-6 sm:mb-8 px-2">
          Join thousands of satisfied customers who trust Appointigo for their appointments
        </p>
        <button 
          onClick={onCTAClick}
          className="px-6 sm:px-8 py-3 sm:py-4 bg-white text-accent-600 font-semibold rounded-lg sm:rounded-xl hover:scale-105 hover:shadow-lg transition-all duration-300 text-base sm:text-lg"
        >
          Book Your First Appointment
        </button>
      </div>
    </section>
  );
};

export default CTASection;
